import { useEffect } from "react";

export default function NativeBanner1() {
  useEffect(() => {

  }, []);

  return (
    <div></div>

  );
} 